/*! Max Mega Menu jQuery Plugin */
!function(e) {
  "use strict";
  e.maxmegamenu = function(n, i) {
      var t = this
        , a = e(n)
        , s = {
          event: a.attr("data-event"),
          effect: a.attr("data-effect"),
          effect_speed: parseInt(a.attr("data-effect-speed")),
          panel_width: a.attr("data-panel-width"),
          panel_inner_width: a.attr("data-panel-inner-width"),
          second_click: a.attr("data-second-click"),
          vertical_behaviour: a.attr("data-vertical-behaviour"),
          document_click: a.attr("data-document-click"),
          breakpoint: a.attr("data-breakpoint"),
          unbind_events: a.attr("data-unbind")
      };
      t.settings = {};
      var l = e("li.mega-menu-megamenu.mega-menu-item-has-children,li.mega-menu-flyout.mega-menu-item-has-children,li.mega-menu-tabbed > ul.mega-sub-menu > li.mega-menu-item-has-children,li.mega-menu-flyout li.mega-menu-item-has-children", n);
      t.hidePanel = function(n, i) {
          i || "slide" != t.settings.effect ? (i && n.siblings(".mega-sub-menu").css("display", "none").delay(t.settings.effect_speed).queue((function() {
              e(this).css("display", "").dequeue()
          }
          )),
          n.siblings(".mega-sub-menu").find(".widget_media_video video").each((function() {
              this.player.pause()
          }
          )),
          n.parent().removeClass("mega-toggle-on").triggerHandler("close_panel"),
          t.addAnimatingClass(n.parent())) : n.siblings(".mega-sub-menu").animate({
              height: "hide"
          }, t.settings.effect_speed, (function() {
              n.siblings(".mega-sub-menu").css("display", ""),
              n.parent().removeClass("mega-toggle-on").triggerHandler("close_panel")
          }
          ))
      }
      ,
      t.addAnimatingClass = function(n) {
          if ("disabled" !== t.settings.effect) {
              e(".mega-animating").removeClass("mega-animating");
              var i = t.settings.effect_speed + parseInt(megamenu.timeout, 10);
              n.addClass("mega-animating"),
              setTimeout((function() {
                  n.removeClass("mega-animating")
              }
              ), i)
          }
      }
      ,
      t.hideAllPanels = function() {
          e(".mega-toggle-on > a.mega-menu-link", a).each((function() {
              t.hidePanel(e(this), !1)
          }
          ))
      }
      ,
      t.hideSiblingPanels = function(n, i) {
          n.parent().parent().find(".mega-toggle-on").children("a.mega-menu-link").each((function() {
              t.hidePanel(e(this), i)
          }
          ))
      }
      ,
      t.isDesktopView = function() {
          return Math.max(window.outerWidth, e(window).width()) > t.settings.breakpoint
      }
      ,
      t.isMobileView = function() {
          return !t.isDesktopView()
      }
      ,
      t.showPanel = function(n) {
          e(".mega-animating").removeClass("mega-animating"),
          t.isMobileView() && n.parent().hasClass("mega-hide-sub-menu-on-mobile") || (t.isDesktopView() && (a.hasClass("mega-menu-horizontal") || a.hasClass("mega-menu-vertical")) && t.hideSiblingPanels(n, !0),
          (t.isMobileView() && a.hasClass("mega-keyboard-navigation") || "accordion" === t.settings.vertical_behaviour) && t.hideSiblingPanels(n, !1),
          t.calculateDynamicSubmenuWidths(n),
          "slide" == t.settings.effect && n.siblings(".mega-sub-menu").css("display", "none").animate({
              height: "show"
          }, t.settings.effect_speed),
          n.parent().addClass("mega-toggle-on").triggerHandler("open_panel"))
      }
      ,
      t.calculateDynamicSubmenuWidths = function(n) {
          if (n.parent().hasClass("mega-menu-megamenu") && t.settings.panel_width && e(t.settings.panel_width).length > 0)
              if (t.isDesktopView()) {
                  var i = a.offset()
                    , s = e(t.settings.panel_width).offset();
                  n.siblings(".mega-sub-menu").css({
                      width: e(t.settings.panel_width).outerWidth(),
                      left: s.left - i.left + "px"
                  })
              } else
                  n.siblings(".mega-sub-menu").css({
                      width: "",
                      left: ""
                  });
          if (n.parent().hasClass("mega-menu-megamenu") && t.settings.panel_inner_width && e(t.settings.panel_inner_width).length > 0) {
              var l = 0;
              l = e(t.settings.panel_inner_width).length ? parseInt(e(t.settings.panel_inner_width).width(), 10) : parseInt(t.settings.panel_inner_width, 10);
              var g = parseInt(n.siblings(".mega-sub-menu").innerWidth(), 10);
              t.isDesktopView() && l > 0 && l < g ? n.siblings(".mega-sub-menu").css({
                  paddingLeft: (g - l) / 2 + "px",
                  paddingRight: (g - l) / 2 + "px"
              }) : n.siblings(".mega-sub-menu").css({
                  paddingLeft: "",
                  paddingRight: ""
              })
          }
      }
      ;
      t.unbindAllEvents = function() {
          e("ul.mega-sub-menu, li.mega-menu-item, a.mega-menu-link", n).off().unbind()
      }
      ,
      t.unbindClickEvents = function() {
          e("a.mega-menu-link", n).off("click.megamenu touchend.megamenu")
      }
      ,
      t.bindMegaMenuEvents = function() {
          t.isDesktopView() && "hover_intent" === t.settings.event && l.hoverIntent({
              over: function() {
                  t.unbindClickEvents(),
                  e(this).hasClass("mega-toggle-on") || t.showPanel(e(this).children("a.mega-menu-link"))
              },
              out: function() {
                  e(this).hasClass("mega-toggle-on") && !e(this).parent().parent().hasClass("mega-menu-tabbed") && t.hidePanel(e(this).children("a.mega-menu-link"), !1)
              },
              timeout: megamenu.timeout,
              interval: megamenu.interval
          }),
          t.isDesktopView() && "hover" === t.settings.event && l.on({
              mouseenter: function() {
                  t.unbindClickEvents(),
                  e(this).hasClass("mega-toggle-on") || t.showPanel(e(this).children("a.mega-menu-link"))
              },
              mouseleave: function() {
                  e(this).hasClass("mega-toggle-on") && !e(this).parent().parent().hasClass("mega-menu-tabbed") && t.hidePanel(e(this).children("a.mega-menu-link"), !1)
              }
          }),
          e(document).on({
              touchmove: function(e) {},
              touchstart: function(e) {}
          }),
          e(window).width() < 769 && (e(".nav-links").height(e(window).height()),
          e(".mega-menu-item-has-children").on("click", (function(n) {
              e(n.target).parent().hasClass("mega-menu-item-has-children") && n.preventDefault(),
              e(this).siblings("li").find("ul").slideUp(),
              e(this).removeClass("mega-toggle-on"),
              e(".mega-sub-menu", this).slideToggle(),
              e(".mega-sub-menu", this).parent().addClass("mega-toggle-on"),
              e(this).toggleClass("mega-toggle-on-new").parent().removeClass("mega-toggle-on-new"),
              e(this).siblings("li").find("ul").slideUp().parent().removeClass("mega-toggle-on-new")
          }
          ))),
          e("body").on("keyup", (function(n) {
              27 === (n.keyCode || n.which) && (a.removeClass("mega-keyboard-navigation"),
              t.hideAllPanels()),
              a.hasClass("mega-keyboard-navigation") && !e(event.target).closest(".mega-menu li").length && (a.removeClass("mega-keyboard-navigation"),
              t.hideAllPanels())
          }
          )),
          a.parent().on("keyup", (function(n) {
              var i = n.keyCode || n.which
                , s = e(n.target);
              9 === i && (a.addClass("mega-keyboard-navigation"),
              s.parent().is(l) ? t.showPanel(s) : t.hideSiblingPanels(s),
              s.hasClass("mega-menu-toggle") && s.toggleClass("mega-menu-open"))
          }
          ))
      }
      ,
      t.monitorView = function() {
          t.isDesktopView() ? a.data("view", "desktop") : (a.data("view", "mobile"),
          t.switchToMobile()),
          t.checkWidth(),
          e(window).resize((function() {
              t.checkWidth()
          }
          ))
      }
      ,
      t.checkWidth = function() {
          t.isMobileView() && "desktop" === a.data("view") && (a.data("view", "mobile"),
          t.switchToMobile()),
          t.isDesktopView() && "mobile" === a.data("view") && (a.data("view", "desktop"),
          t.switchToDesktop()),
          t.isDesktopView() && t.calculateDynamicSubmenuWidths(e("li.mega-menu-megamenu.mega-toggle-on > a.mega-menu-link", a))
      }
      ,
      t.reverseRightAlignedItems = function() {
          e("body").hasClass("rtl") || a.append(a.children("li.mega-item-align-right").get().reverse())
      }
      ,
      t.switchToMobile = function() {
          t.unbindAllEvents(),
          t.bindMegaMenuEvents(),
          t.reverseRightAlignedItems(),
          t.hideAllPanels()
      }
      ,
      t.switchToDesktop = function() {
          t.unbindAllEvents(),
          t.bindMegaMenuEvents(),
          t.reverseRightAlignedItems(),
          t.hideAllPanels()
      }
      ,
      t.init = function() {
          a.triggerHandler("before_mega_menu_init"),
          t.settings = e.extend({}, s, i),
          a.removeClass("mega-no-js"),
          a.siblings(".mega-menu-toggle").on("click", (function(n) {
              e(n.target).is(".mega-menu-toggle-block, .mega-menu-toggle") && e(this).toggleClass("mega-menu-open")
          }
          )),
          "true" == t.settings.unbind_events && t.unbindAllEvents(),
          t.bindMegaMenuEvents(),
          t.monitorView(),
          a.triggerHandler("after_mega_menu_init")
      }
      ,
      t.init()
  }
  ,
  e.fn.maxmegamenu = function(n) {
      return this.each((function() {
          if (void 0 === e(this).data("maxmegamenu")) {
              var i = new e.maxmegamenu(this,n);
              e(this).data("maxmegamenu", i)
          }
      }
      ))
  }
  ,
  e((function() {
      e(".mega-menu").maxmegamenu()
  }
  ))
}(jQuery);
